import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import { useSnackbar } from '../contexts/SnackbarProvider';
import useDataSelect from '../hooks/useDataSelect';
import { useForm } from 'react-hook-form';
import ClientInfoForm from '../components/ClientInfoForm';
import { Typography, Button, Box, Paper, Stack } from '@mui/material';
import { ChevronRight, ArrowBack, Send, InfoOutlined, Timeline } from '@mui/icons-material';
const ClientNewPage = () => {
    const formRef = useRef(null);
    const { showSnackbar } = useSnackbar();
    const [clientData, setClientData] = useState({
        client_code: null,
        client_name: '',
        branch_name: '',
        client_phone: '',
        client_fax: '',
        industry_id: '',
        business_description: '',
        website_url: '',
        payment_method_id: '',
        payment_terms: '',
        credit_terms: '',
        postal_code: '',
        state: '',
        address_line: '',
        items: [{ client_contact_name: '', client_contact_email: '', client_contact_phone: '' }],
    });
    const navigate = useNavigate();
    const [isEditMode, setIsEditMode] = useState(true);

    const { register, handleSubmit, control, watch, formState: { errors }, setValue, reset } = useForm({
        defaultValues: clientData,
    });
    const { dataset: setttings } = useDataSelect('/setting/company');

    const onSubmit = async (data) => {
        if (isEditMode) {
            setIsEditMode(false);

            requestAnimationFrame(() => {
                formRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            });

            return;
        }

        const payload = {
            ...data,
            client_code: data.client_code || null,
        };

        try {
            await axiosInstance.post('/client/new', payload);
            navigate('/clients/new/complete');
        } catch (err) {
            if (process.env.NODE_ENV === 'development') { console.error(err); }
            showSnackbar(err?.response?.data?.message || '登録に失敗しました', 'error');
        }
    };

    return (
        <Box sx={{ maxWidth: 1000, mx: 'auto' }}>

            <Typography variant='h1' mt={5} align='center'>新規会員登録</Typography>
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 4 }}>
                <Timeline />
                <Typography component='h2' variant='h3'>ご登録まの流れ</Typography>
            </Stack>
            <Paper variant='section'>
                <img
                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}${'/uploads/default/ec-register-flow.svg'}`}
                    alt="フロー"
                    style={{ width: '100%' }}
                />
            </Paper>
            {setttings.notice_text && (
                <>
                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 4 }}>
                        <InfoOutlined />
                        <Typography component='h2' variant='h3'>お取引に関する注意事項</Typography>
                    </Stack>
                    <Paper variant='section'>
                        <Typography sx={{ whiteSpace: 'pre-line' }}>{setttings.notice_text}</Typography>
                    </Paper>
                </>
            )}
            {/* 会社情報の入力フォーム */}
            <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} ref={formRef}>
                <ClientInfoForm
                    clientData={clientData}
                    setClientData={setClientData}
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    control={control}
                    watch={watch}
                    reset={reset}
                    isEditMode={isEditMode}
                />

                <div className="button-row">
                    {isEditMode ? (
                        <Button
                            type="button"
                            variant="contained"
                            startIcon={<ChevronRight />}
                            onClick={handleSubmit((data) => {
                                setIsEditMode(false);
                            })}
                        >
                            入力内容を確認する
                        </Button>
                    ) : (
                        <Button
                            type="button"
                            variant="outlined"
                            startIcon={<ArrowBack />}
                            onClick={() => setIsEditMode(true)}
                        >
                            戻る
                        </Button>
                    )}

                    {!isEditMode && (
                        <Button
                            type="submit"
                            variant="contained"
                            startIcon={<Send />}
                        >
                            この内容で送信
                        </Button>
                    )}
                </div>

            </form>
        </Box>
    );
};

export default ClientNewPage;
